module.exports = __webpack_public_path__ + "media/images/emblems/Dinhard-blazon-b0942cdca83f220c447a380ab60b7875.svg";